import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { GoogleApiWrapper } from 'google-maps-react'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'
import QuestionLabel from './question-label'

const API_KEY = process.env.GEO_API_KEY_FE
const MapSearchBox = ({
  action,
  label,
  placeholder,
  defaultValue,
  inputClass,
  groupClassName,
  customLabelClass,
  input,
  meta: { touched, error },
  errorClassName,
  setLoaded,
  setLoading,
  getPublicTransport,
  setSelectAllPt,
  getAddress,
}) => {
  const [address, setAddress] = useState('')
  const [coordinates, setCoordinates] = useState({ lat: null, lng: null })
  const handleSelect = async (value) => {
    setLoading && setLoading()
    const results = await geocodeByAddress(value)
    const latLng = await getLatLng(results[0])
    setLoaded && setLoaded()
    setSelectAllPt && setSelectAllPt(true)
    getPublicTransport && getPublicTransport({ lat: latLng.lat, lng: latLng.lng })
    setAddress(value)
    setCoordinates(latLng)
    getAddress && getAddress({ address: value, lat: latLng.lat, lng: latLng.lng })
    if (input && input.onChange) input.onChange({ ...latLng, address: value })
    if (action) {
      action({ ...latLng, address: value })
    }
  }
  useEffect(() => {
    setAddress(defaultValue || '')
  }, [defaultValue])

  return (
    <div>
      <PlacesAutocomplete value={address} onChange={setAddress} onSelect={handleSelect}>
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => {
          return (
            <div className="relative">
              <p className="hidden">Latitude: {coordinates.lat}</p>
              <p className="hidden">Longitude: {coordinates.lng}</p>
              <div className={groupClassName}>
                <QuestionLabel label={label} customLabelClass={customLabelClass} />
                <input
                  {...getInputProps()}
                  className={inputClass}
                  autoComplete="off"
                  placeholder={placeholder}
                />
              </div>
              {touched && error && <p className={`form-error ${errorClassName}`}>{error}</p>}
              {suggestions.length > 0 && (
                <div className="absolute z-50 px-5 py-1 max-h-64 overflow-y-auto border rounded w-full bg-white">
                  {loading ? <div>...loading</div> : ''}
                  {suggestions.map((suggestion) => (
                    <div
                      key={suggestion.index}
                      className="cursor-pointer py-1 hover:text-primary-orange"
                      {...getSuggestionItemProps(suggestion, {})}
                    >
                      {suggestion.description}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )
        }}
      </PlacesAutocomplete>
    </div>
  )
}

MapSearchBox.propTypes = {
  action: PropTypes.func,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  defaultValue: PropTypes.string,
  inputClass: PropTypes.string,
  groupClassName: PropTypes.string,
  customLabelClass: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object,
  errorClassName: PropTypes.string,
  setLoading: PropTypes.func,
  setLoaded: PropTypes.func,
  getPublicTransport: PropTypes.func,
  setSelectAllPt: PropTypes.func,
  getAddress: PropTypes.func,
}

MapSearchBox.defaultProps = {
  inputClass: `appearance-none outline-none bg-white block w-full text-gray-700 border rounded-md py-3 px-4 leading-tight
  focus:outline-none focus:bg-white`,
  groupClassName: 'mb-3',
  meta: {},
}

export default GoogleApiWrapper({
  apiKey: API_KEY,
  v: '3',
})(MapSearchBox)
